// extracted by mini-css-extract-plugin
export var alternate = "video-and-text-v2-module--alternate--18f78";
export var content = "video-and-text-v2-module--content--6a28e";
export var contentBlock = "video-and-text-v2-module--contentBlock--a22c2";
export var hasTextWeightBold = "video-and-text-v2-module--has-text-weight-bold--d57ac";
export var isUppercase = "video-and-text-v2-module--is-uppercase--542a3";
export var root = "video-and-text-v2-module--root--1f013";
export var title = "video-and-text-v2-module--title--9d8c3";
export var video = "video-and-text-v2-module--video--10a5c";
export var wrapper = "video-and-text-v2-module--wrapper--af255";